<div>
  <hr style="margin:1px" />
  <div style="display: flex; justify-content: space-between; margin: 5px">
    <div>
      {{ leftFooterText }}
    </div>
    <div>
    </div>
    <div>
      <a href="https://www.clepa.eu/privacy-policy/">Privacy policy</a>
    </div>
  </div>
</div>